export const ANIMATION_TYPES = {
  STANDARD: 'standard',
  MATCHING: 'matching',
  SUCCESS: 'success',
  MATCHING_BRANDED_POS_US: 'matching_branded_pos_us',
  MATCHING_BRANDED_AUTO_WARRANTY_US: 'matching_branded_auto_warranty_us',
  MATCHING_BRANDED_TELEPHONE_SYSTEMS_US:
    'matching_branded_telephone_systems_us',
  MATCHING_BRANDED_PAYROLL_SERVICES_US: 'matching_branded_payroll_services_us',
  MATCHING_BRANDED_VEHICLE_TRACKING_US: 'matching_branded_vehicle_tracking_us',
};

export const ANIMATION_SOURCES = {
  STANDARD: '../../../animations/standard.json',
  MATCHING: '../../../animations/matching.json',
  SUCCESS: '../../../animations/success.json',
  MATCHING_BRANDED_POS_US: '../../../animations/matching_POS.json',
  MATCHING_BRANDED_AUTO_WARRANTY_US: '../../../animations/matching_AW.json',
  MATCHING_BRANDED_TELEPHONE_SYSTEMS_US: '../../../animations/matching_TS.json',
  MATCHING_BRANDED_PAYROLL_SERVICES_US:
    '../../../animations/matching_Payroll.json',
  MATCHING_BRANDED_VEHICLE_TRACKING_US: '../../../animations/matching_VT.json',
};
